'use client';

import FullCalendar from '@fullcalendar/react';
import { useCreateOrModifyAppointmentStore } from '~/stores/create-appointment-store';
import { useShallow } from 'zustand/react/shallow';
import { BookableItemSearch } from './BookableItemSearch';
import { StepList } from './StepList';
import { DateTimeSelector } from './DateTimeSelector';
import { AppointmentSlotSelector } from '~/components/appointments/AppointmentSlotSelector';
import { useAppointmentsCalendarStore } from '~/stores/appointments-calendar-store';
import { useState } from 'react';

type AppointmentBuilderProps = {
    calendarRef?: React.RefObject<FullCalendar | null>;
};

export const AppointmentBuilder = ({ calendarRef }: AppointmentBuilderProps) => {
    const { selectedStore } = useAppointmentsCalendarStore(
        useShallow((state) => ({
            selectedStore: state.selectedStore,
        }))
    )

    const { steps } = useCreateOrModifyAppointmentStore(
        useShallow(state => ({
            steps: state.steps
        }))
    );

    const [isSlotFinderOpen, setIsSlotFinderOpen] = useState(false);

    return (
        <div className='space-y-6'>
            <div className='p-4 rounded-xl border border-gray-200 bg-gray-50 space-y-2'>
                <BookableItemSearch storeId={selectedStore?.id || undefined} />
                <StepList />
            </div>

            {steps.length > 0 && (
                <div className='space-y-4'>
                    <AppointmentSlotSelector 
                        storeId={selectedStore?.id} 
                        isOpen={isSlotFinderOpen}
                        onOpenChange={setIsSlotFinderOpen}
                    />
                    <DateTimeSelector onOpenSlotFinder={() => setIsSlotFinderOpen(true)} />
                </div>
            )}
        </div>
    );
};